import Swiper from "swiper";
import {
    Autoplay,
    Navigation,
    Pagination,
    Thumbs,
    FreeMode,
    Mousewheel,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import imagesLoaded from "imagesloaded";
window.imagesLoaded = imagesLoaded;
window.Swiper = Swiper;

const containers_visualizzate_consigliate_bodytype_selection =
    document.querySelectorAll(
        ".swiperVisualizzate, .swiperConsigliate, .bodytype_selection_homepage"
    );

containers_visualizzate_consigliate_bodytype_selection.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        slidesPerView: 1,
        spaceBetween: 15,
        grabCursor: true,
        speed: 1350,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            996: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
            1600: { slidesPerView: 4 },
        },
    });
});

const single_container = document.querySelectorAll(
    ".swiper-promo-homepage, .swiper-promo-service"
);

single_container.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        speed: 1500,
        touchRatio: 1,
        allowTouchMove: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const blocchi_garanzie_lista = document.querySelectorAll(
    ".swiper-blocchi-garanzie-lista"
);

/* Blocchi garanzie lista */
blocchi_garanzie_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let conteggio_desktop = 4;
    if (slides.lehgth > 4) {
        conteggio_desktop = 5;
    }
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 2000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 2,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            370: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: conteggio_desktop,
            },
            1600: {
                slidesPerView: conteggio_desktop,
            },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const altre_offerte_lista = document.querySelectorAll(
    ".swiper-altre-offerte-lista"
);
/* Altre offerte nella lista */
altre_offerte_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            996: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
            1600: {
                slidesPerView: 4,
            },
        },
    });
});

const altre_offerte_lista_preferiti = document.querySelectorAll(
    ".swiper-altre-offerte-lista-preferiti"
);

/* Altre offerte nella lista */
altre_offerte_lista_preferiti.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 6;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            996: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 5,
            },
            1600: {
                slidesPerView: 5,
            },
        },
    });
});

const swiper_warranties_search_engine = document.querySelectorAll(
    ".swiper_warranties_search_engine"
);

/* Bottoni Garanzie su motore di ricerca */
swiper_warranties_search_engine.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        slidesPerView: 3,
        grabCursor: true,
        spaceBetween: 10,
        disableOnInteraction: true,
        speed: 1800,
        touchRatio: 1,
        allowTouchMove: true,
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const swiper_newsflash = document.querySelectorAll(".swiper_newsflash");

// /* NewsFlash */
swiper_newsflash.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 1;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        slidesPerView: 1,
        grabCursor: true,
        disableOnInteraction: true,
        speed: 900,
        touchRatio: 1,
        allowTouchMove: true,
        on: {
            init: function () {
                var prevButton = this.navigation.$prevEl;
                var nextButton = this.navigation.$nextEl;

                $(prevButton).addClass("swiper-button-prev_white");
                $(nextButton).addClass("swiper-button-next_white");
            },
        },
    });
});

/* Gallery Thumbs */
const swiper_scheda_full_thumbs = new Swiper(".swiper-scheda-thumbs", {
    modules: [Navigation, Thumbs, FreeMode, Autoplay, Mousewheel],
    loop: true,
    spaceBetween: 5,
    mousewheel: true,
    freeMode: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 1500,
              },
          }
        : {}),
    speed: 1800,
    watchSlidesProgress: true,
    touchRatio: 1,
    allowTouchMove: true,
    breakpoints: {
        0: { slidesPerView: 4 },
        768: { slidesPerView: 6 },
        1024: { slidesPerView: 8 },
        1440: { slidesPerView: 8 },
    },
});

/* Gallery */
const swiper_scheda_full = new Swiper(".swiper-scheda", {
    modules: [Navigation, Thumbs, Mousewheel],
    loop: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 600,
              },
          }
        : {}),
    speed: 500,
    mousewheel: true,
    spaceBetween: 0,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper_scheda_full_thumbs,
    },
});

const altre_offerte = new Swiper(".swiper-altre-offerte", {
    modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
    loop: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 4000,
              },
          }
        : {}),
    grabCursor: true,
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 5,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        450: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
        996: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
        1600: {
            slidesPerView: 4,
        },
    },
});

// /* Stock nelle landing */
const stock_landing = document.querySelectorAll(".swiper-stock-landing");

stock_landing.forEach((container) => {
    // /* Stock nelle landing */
    new Swiper(container, {
        modules: [Autoplay, Navigation, Mousewheel],
        slidesPerView: 3,
        spaceBetween: 20,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1800,
                  },
              }
            : {}),
        speed: 500,
        loop: true,
        mousewheel: true,
        grabCursor: true,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
            1440: { slidesPerView: 3 },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

// /* Slider Immagini Landing page */
const swiper_slider_landing = new Swiper(".swiper-slider-landing", {
    modules: [Autoplay, Navigation, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 20,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 2500,
              },
          }
        : {}),
    speed: 2000,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// /* Slider Video Youtube e Vimeo */
const video_landing = new Swiper(".swiper-video-landing", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: false,
    speed: 850,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 40 },
        768: { slidesPerView: 1, spaceBetween: 40 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 2, spaceBetween: 50 },
    },
});
